/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 *
 * Design System — Icon registry
 *
 * Auto-generated by `src/design-system/assets/icons/generate-registry.js`.
 * Do not edit by hand — re-run the script after adding or removing icons.
 */
import * as React from 'react';

import { ReactComponent as ActionableAdd } from 'design-system/assets/icons/actionable/add.svg';
import { ReactComponent as ActionableAreaField } from 'design-system/assets/icons/actionable/area-field.svg';
import { ReactComponent as ActionableArrowLeft } from 'design-system/assets/icons/actionable/arrow-left.svg';
import { ReactComponent as ActionableArrowRight } from 'design-system/assets/icons/actionable/arrow-right.svg';
import { ReactComponent as ActionableArrowUp } from 'design-system/assets/icons/actionable/arrow-up.svg';
import { ReactComponent as ActionableBack } from 'design-system/assets/icons/actionable/back.svg';
import { ReactComponent as ActionableChevronCollapse } from 'design-system/assets/icons/actionable/chevron-collapse.svg';
import { ReactComponent as ActionableChevronExpand } from 'design-system/assets/icons/actionable/chevron-expand.svg';
import { ReactComponent as ActionableChevronLeft } from 'design-system/assets/icons/actionable/chevron-left.svg';
import { ReactComponent as ActionableChevronRight } from 'design-system/assets/icons/actionable/chevron-right.svg';
import { ReactComponent as ActionableClear } from 'design-system/assets/icons/actionable/clear.svg';
import { ReactComponent as ActionableClone } from 'design-system/assets/icons/actionable/clone.svg';
import { ReactComponent as ActionableClose } from 'design-system/assets/icons/actionable/close.svg';
import { ReactComponent as ActionableCollapseHeight } from 'design-system/assets/icons/actionable/collapse-height.svg';
import { ReactComponent as ActionableCollapse } from 'design-system/assets/icons/actionable/collapse.svg';
import { ReactComponent as ActionableCopy } from 'design-system/assets/icons/actionable/copy.svg';
import { ReactComponent as ActionableCreateDraft } from 'design-system/assets/icons/actionable/create-draft.svg';
import { ReactComponent as ActionableDeleteBin } from 'design-system/assets/icons/actionable/delete-bin.svg';
import { ReactComponent as ActionableDeleteOutline } from 'design-system/assets/icons/actionable/delete-outline.svg';
import { ReactComponent as ActionableDelete } from 'design-system/assets/icons/actionable/delete.svg';
import { ReactComponent as ActionableEdit } from 'design-system/assets/icons/actionable/edit.svg';
import { ReactComponent as ActionableExpandHeight } from 'design-system/assets/icons/actionable/expand-height.svg';
import { ReactComponent as ActionableExpand } from 'design-system/assets/icons/actionable/expand.svg';
import { ReactComponent as ActionableExport } from 'design-system/assets/icons/actionable/export.svg';
import { ReactComponent as ActionableEyeOff } from 'design-system/assets/icons/actionable/eye-off.svg';
import { ReactComponent as ActionableEyeOn } from 'design-system/assets/icons/actionable/eye-on.svg';
import { ReactComponent as ActionableFeedback } from 'design-system/assets/icons/actionable/feedback.svg';
import { ReactComponent as ActionableFieldMap } from 'design-system/assets/icons/actionable/field-map.svg';
import { ReactComponent as ActionableFields } from 'design-system/assets/icons/actionable/fields.svg';
import { ReactComponent as ActionableFile } from 'design-system/assets/icons/actionable/file.svg';
import { ReactComponent as ActionableFilter1 } from 'design-system/assets/icons/actionable/filter-1.svg';
import { ReactComponent as ActionableFilter } from 'design-system/assets/icons/actionable/filter.svg';
import { ReactComponent as ActionableForward } from 'design-system/assets/icons/actionable/forward.svg';
import { ReactComponent as ActionableGenerateKey } from 'design-system/assets/icons/actionable/generate-key.svg';
import { ReactComponent as ActionableGroup } from 'design-system/assets/icons/actionable/group.svg';
import { ReactComponent as ActionableHandle } from 'design-system/assets/icons/actionable/handle.svg';
import { ReactComponent as ActionableInsightsResendEmail } from 'design-system/assets/icons/actionable/insights-resend-email.svg';
import { ReactComponent as ActionableKebab } from 'design-system/assets/icons/actionable/kebab.svg';
import { ReactComponent as ActionableLineage } from 'design-system/assets/icons/actionable/lineage.svg';
import { ReactComponent as ActionableMergeStudio } from 'design-system/assets/icons/actionable/merge-studio.svg';
import { ReactComponent as ActionableMerge } from 'design-system/assets/icons/actionable/merge.svg';
import { ReactComponent as ActionableNestCondition } from 'design-system/assets/icons/actionable/nest-condition.svg';
import { ReactComponent as ActionableNote } from 'design-system/assets/icons/actionable/note.svg';
import { ReactComponent as ActionableOperations } from 'design-system/assets/icons/actionable/operations.svg';
import { ReactComponent as ActionablePalette } from 'design-system/assets/icons/actionable/palette.svg';
import { ReactComponent as ActionablePipelineOpenVersion } from 'design-system/assets/icons/actionable/pipeline-open-version.svg';
import { ReactComponent as ActionablePipelinePause } from 'design-system/assets/icons/actionable/pipeline-pause.svg';
import { ReactComponent as ActionablePipelineRestoreVersion } from 'design-system/assets/icons/actionable/pipeline-restore-version.svg';
import { ReactComponent as ActionablePipelineResume } from 'design-system/assets/icons/actionable/pipeline-resume.svg';
import { ReactComponent as ActionablePipelineVisualChanges } from 'design-system/assets/icons/actionable/pipeline-visual-changes.svg';
import { ReactComponent as ActionableRefresh } from 'design-system/assets/icons/actionable/refresh.svg';
import { ReactComponent as ActionableRemoveGroup } from 'design-system/assets/icons/actionable/remove-group.svg';
import { ReactComponent as ActionableSchedule } from 'design-system/assets/icons/actionable/schedule.svg';
import { ReactComponent as ActionableSearch } from 'design-system/assets/icons/actionable/search.svg';
import { ReactComponent as ActionableSendBottom } from 'design-system/assets/icons/actionable/send-bottom.svg';
import { ReactComponent as ActionableSendTop } from 'design-system/assets/icons/actionable/send-top.svg';
import { ReactComponent as ActionableSettingsFilled } from 'design-system/assets/icons/actionable/settings-filled.svg';
import { ReactComponent as ActionableSettings } from 'design-system/assets/icons/actionable/settings.svg';
import { ReactComponent as ActionableSpinner } from 'design-system/assets/icons/actionable/spinner.svg';
import { ReactComponent as ActionableStatus } from 'design-system/assets/icons/actionable/status.svg';
import { ReactComponent as ActionableTagVariant } from 'design-system/assets/icons/actionable/tag-variant.svg';
import { ReactComponent as ActionableTags } from 'design-system/assets/icons/actionable/tags.svg';
import { ReactComponent as ActionableTick } from 'design-system/assets/icons/actionable/tick.svg';
import { ReactComponent as ActionableUndo } from 'design-system/assets/icons/actionable/undo.svg';
import { ReactComponent as ActionableUngroup } from 'design-system/assets/icons/actionable/ungroup.svg';
import { ReactComponent as ActionableUploadFile } from 'design-system/assets/icons/actionable/upload-file.svg';
import { ReactComponent as ActionableUpload } from 'design-system/assets/icons/actionable/upload.svg';
import { ReactComponent as ActionableViewConfiguration } from 'design-system/assets/icons/actionable/view-configuration.svg';
import { ReactComponent as ActionsAddToList } from 'design-system/assets/icons/actions/add-to-list.svg';
import { ReactComponent as ActionsAddToMarketoProgram } from 'design-system/assets/icons/actions/add-to-marketo-program.svg';
import { ReactComponent as ActionsAddToSalesforceCampaign } from 'design-system/assets/icons/actions/add-to-salesforce-campaign.svg';
import { ReactComponent as ActionsAddressGpt } from 'design-system/assets/icons/actions/address-gpt.svg';
import { ReactComponent as ActionsConvertSalesforceLead } from 'design-system/assets/icons/actions/convert-salesforce-lead.svg';
import { ReactComponent as ActionsCreateExternalRecord } from 'design-system/assets/icons/actions/create-external-record.svg';
import { ReactComponent as ActionsCreateFile } from 'design-system/assets/icons/actions/create-file.svg';
import { ReactComponent as ActionsCreateMsTeamsChannel } from 'design-system/assets/icons/actions/create-ms-teams-channel.svg';
import { ReactComponent as ActionsCreateSalesforcceFile } from 'design-system/assets/icons/actions/create-salesforcce-file.svg';
import { ReactComponent as ActionsCreateSalesforcceTask } from 'design-system/assets/icons/actions/create-salesforcce-task.svg';
import { ReactComponent as ActionsCreateSyncariRecord } from 'design-system/assets/icons/actions/create-syncari-record.svg';
import { ReactComponent as ActionsCreateZendeskTicket } from 'design-system/assets/icons/actions/create-zendesk-ticket.svg';
import { ReactComponent as ActionsCustomAction1 } from 'design-system/assets/icons/actions/custom-action-1.svg';
import { ReactComponent as ActionsCustomAction } from 'design-system/assets/icons/actions/custom-action.svg';
import { ReactComponent as ActionsDeleteExternalRecord } from 'design-system/assets/icons/actions/delete-external-record.svg';
import { ReactComponent as ActionsDeleteSyncariRecord } from 'design-system/assets/icons/actions/delete-syncari-record.svg';
import { ReactComponent as ActionsExportRecordsToCsv } from 'design-system/assets/icons/actions/export-records-to-csv.svg';
import { ReactComponent as ActionsGenericAction } from 'design-system/assets/icons/actions/generic_action.svg';
import { ReactComponent as ActionsMicrosoftTeams } from 'design-system/assets/icons/actions/microsoft-teams.svg';
import { ReactComponent as ActionsNameGpt } from 'design-system/assets/icons/actions/name-gpt.svg';
import { ReactComponent as ActionsPlaceholderAction } from 'design-system/assets/icons/actions/placeholder-action.svg';
import { ReactComponent as ActionsRemoveFromMarketoList } from 'design-system/assets/icons/actions/remove-from-marketo-list.svg';
import { ReactComponent as ActionsRespondToWebhook } from 'design-system/assets/icons/actions/respond-to-webhook.svg';
import { ReactComponent as ActionsRetryRecord } from 'design-system/assets/icons/actions/retry-record.svg';
import { ReactComponent as ActionsSendEmail } from 'design-system/assets/icons/actions/send-email.svg';
import { ReactComponent as ActionsSendSlackMessage } from 'design-system/assets/icons/actions/send-slack-message.svg';
import { ReactComponent as ActionsSentimentGpt } from 'design-system/assets/icons/actions/sentiment-gpt.svg';
import { ReactComponent as ActionsSlackSendMessage } from 'design-system/assets/icons/actions/slack--send-message.svg';
import { ReactComponent as ActionsUpdateExternalRecord } from 'design-system/assets/icons/actions/update-external-record.svg';
import { ReactComponent as ActionsUpdateSyncariRecord } from 'design-system/assets/icons/actions/update-syncari-record.svg';
import { ReactComponent as BrandAvatar } from 'design-system/assets/icons/brand/avatar.svg';
import { ReactComponent as BrandBrandCollapsed } from 'design-system/assets/icons/brand/brand-collapsed.svg';
import { ReactComponent as BrandBrandExpanded } from 'design-system/assets/icons/brand/brand-expanded.svg';
import { ReactComponent as BrandSyncaroo } from 'design-system/assets/icons/brand/syncaroo.svg';
import { ReactComponent as FieldTypeBoolean } from 'design-system/assets/icons/field-type/boolean.svg';
import { ReactComponent as FieldTypeDate } from 'design-system/assets/icons/field-type/date.svg';
import { ReactComponent as FieldTypeDatetime } from 'design-system/assets/icons/field-type/datetime.svg';
import { ReactComponent as FieldTypeDouble } from 'design-system/assets/icons/field-type/double.svg';
import { ReactComponent as FieldTypeId } from 'design-system/assets/icons/field-type/id.svg';
import { ReactComponent as FieldTypeInteger } from 'design-system/assets/icons/field-type/integer.svg';
import { ReactComponent as FieldTypeObject } from 'design-system/assets/icons/field-type/object.svg';
import { ReactComponent as FieldTypePicklist } from 'design-system/assets/icons/field-type/picklist.svg';
import { ReactComponent as FieldTypeReference } from 'design-system/assets/icons/field-type/reference.svg';
import { ReactComponent as FieldTypeTextarea } from 'design-system/assets/icons/field-type/textarea.svg';
import { ReactComponent as FieldTypeUrl } from 'design-system/assets/icons/field-type/url.svg';
import { ReactComponent as FunctionsAbsoluteValue } from 'design-system/assets/icons/functions/absolute-value.svg';
import { ReactComponent as FunctionsAddToDate } from 'design-system/assets/icons/functions/add-to-date.svg';
import { ReactComponent as FunctionsAddToList } from 'design-system/assets/icons/functions/add-to-list.svg';
import { ReactComponent as FunctionsAdd } from 'design-system/assets/icons/functions/add.svg';
import { ReactComponent as FunctionsAidentifiedPeopleEnrichment } from 'design-system/assets/icons/functions/aidentified-people-enrichment.svg';
import { ReactComponent as FunctionsApexanalyticCompanyEnrichment } from 'design-system/assets/icons/functions/apexanalytic-company-enrichment.svg';
import { ReactComponent as FunctionsAttachRecord } from 'design-system/assets/icons/functions/attach-record.svg';
import { ReactComponent as FunctionsAutoIncrement } from 'design-system/assets/icons/functions/auto-increment.svg';
import { ReactComponent as FunctionsAverage } from 'design-system/assets/icons/functions/average.svg';
import { ReactComponent as FunctionsCache } from 'design-system/assets/icons/functions/cache.svg';
import { ReactComponent as FunctionsCamelCase } from 'design-system/assets/icons/functions/camel-case.svg';
import { ReactComponent as FunctionsCapitalize } from 'design-system/assets/icons/functions/capitalize.svg';
import { ReactComponent as FunctionsCeiling } from 'design-system/assets/icons/functions/ceiling.svg';
import { ReactComponent as FunctionsCharacterAtIndex } from 'design-system/assets/icons/functions/character-at-index.svg';
import { ReactComponent as FunctionsComputeDataQuality } from 'design-system/assets/icons/functions/compute-data-quality.svg';
import { ReactComponent as FunctionsComputeRatio } from 'design-system/assets/icons/functions/compute-ratio.svg';
import { ReactComponent as FunctionsComputingDataQuality } from 'design-system/assets/icons/functions/computing-data-quality.svg';
import { ReactComponent as FunctionsConcatenate } from 'design-system/assets/icons/functions/concatenate.svg';
import { ReactComponent as FunctionsConvertJsonToString } from 'design-system/assets/icons/functions/convert-json-to-string.svg';
import { ReactComponent as FunctionsCount } from 'design-system/assets/icons/functions/count.svg';
import { ReactComponent as FunctionsDateDifference } from 'design-system/assets/icons/functions/date-difference.svg';
import { ReactComponent as FunctionsDateFormat } from 'design-system/assets/icons/functions/date-format.svg';
import { ReactComponent as FunctionsDayOfMonth } from 'design-system/assets/icons/functions/day-of-month.svg';
import { ReactComponent as FunctionsDayOfWeek } from 'design-system/assets/icons/functions/day-of-week.svg';
import { ReactComponent as FunctionsDayOfYear } from 'design-system/assets/icons/functions/day-of-year.svg';
import { ReactComponent as FunctionsDecision } from 'design-system/assets/icons/functions/decision.svg';
import { ReactComponent as FunctionsDecode } from 'design-system/assets/icons/functions/decode.svg';
import { ReactComponent as FunctionsDecrementValue } from 'design-system/assets/icons/functions/decrement-value.svg';
import { ReactComponent as FunctionsDecrypt } from 'design-system/assets/icons/functions/decrypt.svg';
import { ReactComponent as FunctionsDeduplicate } from 'design-system/assets/icons/functions/deduplicate.svg';
import { ReactComponent as FunctionsEncode } from 'design-system/assets/icons/functions/encode.svg';
import { ReactComponent as FunctionsEncrypt } from 'design-system/assets/icons/functions/encrypt.svg';
import { ReactComponent as FunctionsEnrichCompany } from 'design-system/assets/icons/functions/enrich-company.svg';
import { ReactComponent as FunctionsEnrichPerson } from 'design-system/assets/icons/functions/enrich-person.svg';
import { ReactComponent as FunctionsExtractDomain } from 'design-system/assets/icons/functions/extract-domain.svg';
import { ReactComponent as FunctionsExtractText } from 'design-system/assets/icons/functions/extract-text.svg';
import { ReactComponent as FunctionsFindInList } from 'design-system/assets/icons/functions/find-in-list.svg';
import { ReactComponent as FunctionsFirst } from 'design-system/assets/icons/functions/first.svg';
import { ReactComponent as FunctionsFloor } from 'design-system/assets/icons/functions/floor.svg';
import { ReactComponent as FunctionsGenericFunction } from 'design-system/assets/icons/functions/generic_function.svg';
import { ReactComponent as FunctionsGetListItem } from 'design-system/assets/icons/functions/get-list-item.svg';
import { ReactComponent as FunctionsIncrementValue } from 'design-system/assets/icons/functions/increment-value.svg';
import { ReactComponent as FunctionsIndexOf } from 'design-system/assets/icons/functions/index-of.svg';
import { ReactComponent as FunctionsIsAfterNow } from 'design-system/assets/icons/functions/is-after-now.svg';
import { ReactComponent as FunctionsIsBeforeNow } from 'design-system/assets/icons/functions/is-before-now.svg';
import { ReactComponent as FunctionsIsEmpty } from 'design-system/assets/icons/functions/is-empty.svg';
import { ReactComponent as FunctionsJoin } from 'design-system/assets/icons/functions/join.svg';
import { ReactComponent as FunctionsLast } from 'design-system/assets/icons/functions/last.svg';
import { ReactComponent as FunctionsLength1 } from 'design-system/assets/icons/functions/length-1.svg';
import { ReactComponent as FunctionsLength } from 'design-system/assets/icons/functions/length.svg';
import { ReactComponent as FunctionsLookupDatasetRecords } from 'design-system/assets/icons/functions/lookup-dataset-records.svg';
import { ReactComponent as FunctionsLookupExternalRecords } from 'design-system/assets/icons/functions/lookup-external-records.svg';
import { ReactComponent as FunctionsLookupSyncariRecords } from 'design-system/assets/icons/functions/lookup-syncari-records.svg';
import { ReactComponent as FunctionsLoop1 } from 'design-system/assets/icons/functions/loop-1.svg';
import { ReactComponent as FunctionsLoop } from 'design-system/assets/icons/functions/loop.svg';
import { ReactComponent as FunctionsLower } from 'design-system/assets/icons/functions/lower.svg';
import { ReactComponent as FunctionsLpad } from 'design-system/assets/icons/functions/lpad.svg';
import { ReactComponent as FunctionsLtrim1 } from 'design-system/assets/icons/functions/ltrim-1.svg';
import { ReactComponent as FunctionsLtrim } from 'design-system/assets/icons/functions/ltrim.svg';
import { ReactComponent as FunctionsMaximumValue } from 'design-system/assets/icons/functions/maximum-value.svg';
import { ReactComponent as FunctionsMd5Hash } from 'design-system/assets/icons/functions/md5-hash.svg';
import { ReactComponent as FunctionsMd5 } from 'design-system/assets/icons/functions/md5.svg';
import { ReactComponent as FunctionsMinimumValue } from 'design-system/assets/icons/functions/minimum-value.svg';
import { ReactComponent as FunctionsMultiply } from 'design-system/assets/icons/functions/multiply.svg';
import { ReactComponent as FunctionsNow } from 'design-system/assets/icons/functions/now.svg';
import { ReactComponent as FunctionsParseJsonArray } from 'design-system/assets/icons/functions/parse-json-array.svg';
import { ReactComponent as FunctionsParseJsonObject } from 'design-system/assets/icons/functions/parse-json-object.svg';
import { ReactComponent as FunctionsParseJsonToList } from 'design-system/assets/icons/functions/parse-json-to-list.svg';
import { ReactComponent as FunctionsParseJsonToObject } from 'design-system/assets/icons/functions/parse-json-to-object.svg';
import { ReactComponent as FunctionsPhoneNumberFormat } from 'design-system/assets/icons/functions/phone-number-format.svg';
import { ReactComponent as FunctionsPlaceholderFunction } from 'design-system/assets/icons/functions/placeholder-function.svg';
import { ReactComponent as FunctionsRandomNumber } from 'design-system/assets/icons/functions/random-number.svg';
import { ReactComponent as FunctionsRemoveDuplicates } from 'design-system/assets/icons/functions/remove-duplicates.svg';
import { ReactComponent as FunctionsRemoveFromList } from 'design-system/assets/icons/functions/remove-from-list.svg';
import { ReactComponent as FunctionsRemoveNonPrintable } from 'design-system/assets/icons/functions/remove-non-printable.svg';
import { ReactComponent as FunctionsReplace } from 'design-system/assets/icons/functions/replace.svg';
import { ReactComponent as FunctionsReverseList } from 'design-system/assets/icons/functions/reverse-list.svg';
import { ReactComponent as FunctionsReverseString } from 'design-system/assets/icons/functions/reverse-string.svg';
import { ReactComponent as FunctionsRound } from 'design-system/assets/icons/functions/round.svg';
import { ReactComponent as FunctionsRpad } from 'design-system/assets/icons/functions/rpad.svg';
import { ReactComponent as FunctionsRtrim } from 'design-system/assets/icons/functions/rtrim.svg';
import { ReactComponent as FunctionsSalesintelCompanyEnrichment } from 'design-system/assets/icons/functions/salesintel-company-enrichment.svg';
import { ReactComponent as FunctionsSetValue } from 'design-system/assets/icons/functions/set-value.svg';
import { ReactComponent as FunctionsSimilarwebTrafficData } from 'design-system/assets/icons/functions/similarweb-traffic-data.svg';
import { ReactComponent as FunctionsSort } from 'design-system/assets/icons/functions/sort.svg';
import { ReactComponent as FunctionsSplit } from 'design-system/assets/icons/functions/split.svg';
import { ReactComponent as FunctionsStandardDeviation } from 'design-system/assets/icons/functions/standard-deviation.svg';
import { ReactComponent as FunctionsStripTags } from 'design-system/assets/icons/functions/strip-tags.svg';
import { ReactComponent as FunctionsSubstractFromDate } from 'design-system/assets/icons/functions/substract-from-date.svg';
import { ReactComponent as FunctionsSubstring } from 'design-system/assets/icons/functions/substring.svg';
import { ReactComponent as FunctionsSubtract } from 'design-system/assets/icons/functions/subtract.svg';
import { ReactComponent as FunctionsSum } from 'design-system/assets/icons/functions/sum.svg';
import { ReactComponent as FunctionsSwitch } from 'design-system/assets/icons/functions/switch.svg';
import { ReactComponent as FunctionsTimeTicker } from 'design-system/assets/icons/functions/time-ticker.svg';
import { ReactComponent as FunctionsTitle } from 'design-system/assets/icons/functions/title.svg';
import { ReactComponent as FunctionsTranslate } from 'design-system/assets/icons/functions/translate.svg';
import { ReactComponent as FunctionsTrim } from 'design-system/assets/icons/functions/trim.svg';
import { ReactComponent as FunctionsUpper } from 'design-system/assets/icons/functions/upper.svg';
import { ReactComponent as FunctionsUrlEncode } from 'design-system/assets/icons/functions/url-encode.svg';
import { ReactComponent as FunctionsUuid } from 'design-system/assets/icons/functions/uuid.svg';
import { ReactComponent as MiscellaneousAvatar } from 'design-system/assets/icons/miscellaneous/avatar.svg';
import { ReactComponent as MiscellaneousCollapse } from 'design-system/assets/icons/miscellaneous/collapse.svg';
import { ReactComponent as MiscellaneousErrorOutline } from 'design-system/assets/icons/miscellaneous/error-outline.svg';
import { ReactComponent as MiscellaneousError } from 'design-system/assets/icons/miscellaneous/error.svg';
import { ReactComponent as MiscellaneousExpand } from 'design-system/assets/icons/miscellaneous/expand.svg';
import { ReactComponent as MiscellaneousFalse } from 'design-system/assets/icons/miscellaneous/false.svg';
import { ReactComponent as MiscellaneousHelpOutline } from 'design-system/assets/icons/miscellaneous/help-outline.svg';
import { ReactComponent as MiscellaneousHelp } from 'design-system/assets/icons/miscellaneous/help.svg';
import { ReactComponent as MiscellaneousIndicatorBlue } from 'design-system/assets/icons/miscellaneous/indicator-blue.svg';
import { ReactComponent as MiscellaneousIndicatorGreen } from 'design-system/assets/icons/miscellaneous/indicator-green.svg';
import { ReactComponent as MiscellaneousIndicatorGrey } from 'design-system/assets/icons/miscellaneous/indicator-grey.svg';
import { ReactComponent as MiscellaneousIndicatorOrange } from 'design-system/assets/icons/miscellaneous/indicator-orange.svg';
import { ReactComponent as MiscellaneousIndicatorRed } from 'design-system/assets/icons/miscellaneous/indicator-red.svg';
import { ReactComponent as MiscellaneousInfoGrayOutline } from 'design-system/assets/icons/miscellaneous/info--gray-outline.svg';
import { ReactComponent as MiscellaneousInfoGray } from 'design-system/assets/icons/miscellaneous/info-gray.svg';
import { ReactComponent as MiscellaneousInfoOutline } from 'design-system/assets/icons/miscellaneous/info-outline.svg';
import { ReactComponent as MiscellaneousInfo } from 'design-system/assets/icons/miscellaneous/info.svg';
import { ReactComponent as MiscellaneousInstanceLogo } from 'design-system/assets/icons/miscellaneous/instance-logo.svg';
import { ReactComponent as MiscellaneousNotificationsEmpty } from 'design-system/assets/icons/miscellaneous/notifications-empty.svg';
import { ReactComponent as MiscellaneousSlash } from 'design-system/assets/icons/miscellaneous/slash.svg';
import { ReactComponent as MiscellaneousSuccessOutline } from 'design-system/assets/icons/miscellaneous/success-outline.svg';
import { ReactComponent as MiscellaneousSuccess } from 'design-system/assets/icons/miscellaneous/success.svg';
import { ReactComponent as MiscellaneousSyncaroo } from 'design-system/assets/icons/miscellaneous/syncaroo.svg';
import { ReactComponent as MiscellaneousWarningOutline } from 'design-system/assets/icons/miscellaneous/warning-outline.svg';
import { ReactComponent as MiscellaneousWarning } from 'design-system/assets/icons/miscellaneous/warning.svg';
import { ReactComponent as SectionsActions } from 'design-system/assets/icons/sections/actions.svg';
import { ReactComponent as SectionsAnnotations } from 'design-system/assets/icons/sections/annotations.svg';
import { ReactComponent as SectionsBody } from 'design-system/assets/icons/sections/body.svg';
import { ReactComponent as SectionsCustomFragments } from 'design-system/assets/icons/sections/custom-fragments.svg';
import { ReactComponent as SectionsFragments } from 'design-system/assets/icons/sections/fragments.svg';
import { ReactComponent as SectionsFunctions } from 'design-system/assets/icons/sections/functions.svg';
import { ReactComponent as SectionsHeaders } from 'design-system/assets/icons/sections/headers.svg';
import { ReactComponent as SectionsPagination } from 'design-system/assets/icons/sections/pagination.svg';
import { ReactComponent as SectionsRecords } from 'design-system/assets/icons/sections/records.svg';
import { ReactComponent as SectionsSchema } from 'design-system/assets/icons/sections/schema.svg';
import { ReactComponent as SectionsSynapseEntities } from 'design-system/assets/icons/sections/synapse-entities.svg';
import { ReactComponent as SectionsSyncFromEntities } from 'design-system/assets/icons/sections/sync-from-entities.svg';
import { ReactComponent as SectionsSyncToEntities } from 'design-system/assets/icons/sections/sync-to-entities.svg';
import { ReactComponent as SectionsTesting } from 'design-system/assets/icons/sections/testing.svg';
import { ReactComponent as SectionsVariables } from 'design-system/assets/icons/sections/variables.svg';
import { ReactComponent as SettingsAccessControl } from 'design-system/assets/icons/settings/access-control.svg';
import { ReactComponent as SettingsBranding } from 'design-system/assets/icons/settings/branding.svg';
import { ReactComponent as SettingsDataStore } from 'design-system/assets/icons/settings/data-store.svg';
import { ReactComponent as SettingsDebugFlag } from 'design-system/assets/icons/settings/debug-flag.svg';
import { ReactComponent as SettingsInsightsSharing } from 'design-system/assets/icons/settings/insights-sharing.svg';
import { ReactComponent as SettingsInstances } from 'design-system/assets/icons/settings/instances.svg';
import { ReactComponent as SettingsNotifications } from 'design-system/assets/icons/settings/notifications.svg';
import { ReactComponent as SettingsRealtimePipelines } from 'design-system/assets/icons/settings/realtime-pipelines.svg';
import { ReactComponent as SettingsServiceCredentials } from 'design-system/assets/icons/settings/service-credentials.svg';
import { ReactComponent as SettingsSingleSignOn } from 'design-system/assets/icons/settings/single-sign-on.svg';
import { ReactComponent as SettingsSubscriptionProfile } from 'design-system/assets/icons/settings/subscription-profile.svg';
import { ReactComponent as SettingsUsers } from 'design-system/assets/icons/settings/users.svg';
import { ReactComponent as SidebarBusinessInactive } from 'design-system/assets/icons/sidebar/business-inactive.svg';
import { ReactComponent as SidebarDataInactive } from 'design-system/assets/icons/sidebar/data-inactive.svg';
import { ReactComponent as SidebarImportedInactive } from 'design-system/assets/icons/sidebar/imported-inactive.svg';
import { ReactComponent as SidebarInsightsInactive } from 'design-system/assets/icons/sidebar/insights-inactive.svg';
import { ReactComponent as SidebarLogsInactive } from 'design-system/assets/icons/sidebar/logs-inactive.svg';
import { ReactComponent as SidebarOptionCollapse } from 'design-system/assets/icons/sidebar/option-collapse.svg';
import { ReactComponent as SidebarSchemaInactive } from 'design-system/assets/icons/sidebar/schema-inactive.svg';
import { ReactComponent as SidebarSettingsInactive } from 'design-system/assets/icons/sidebar/settings-inactive.svg';
import { ReactComponent as SidebarSynapseInactive } from 'design-system/assets/icons/sidebar/synapse-inactive.svg';
import { ReactComponent as SidebarSyncInactive } from 'design-system/assets/icons/sidebar/sync-inactive.svg';
import { ReactComponent as SidebarColorBusinessActive } from 'design-system/assets/icons/sidebar-color/business-active.svg';
import { ReactComponent as SidebarColorDataActive } from 'design-system/assets/icons/sidebar-color/data-active.svg';
import { ReactComponent as SidebarColorImportedActive } from 'design-system/assets/icons/sidebar-color/imported-active.svg';
import { ReactComponent as SidebarColorInsightsActive } from 'design-system/assets/icons/sidebar-color/insights-active.svg';
import { ReactComponent as SidebarColorLogsActive } from 'design-system/assets/icons/sidebar-color/logs-active.svg';
import { ReactComponent as SidebarColorOptionExpand } from 'design-system/assets/icons/sidebar-color/option-expand.svg';
import { ReactComponent as SidebarColorSchemaActive } from 'design-system/assets/icons/sidebar-color/schema-active.svg';
import { ReactComponent as SidebarColorSettingsActive } from 'design-system/assets/icons/sidebar-color/settings-active.svg';
import { ReactComponent as SidebarColorSynapseActive } from 'design-system/assets/icons/sidebar-color/synapse-active.svg';
import { ReactComponent as SidebarColorSyncActive } from 'design-system/assets/icons/sidebar-color/sync-active.svg';
import { ReactComponent as SynapsesAirtable } from 'design-system/assets/icons/synapses/airtable.svg';
import { ReactComponent as SynapsesAmplitude } from 'design-system/assets/icons/synapses/amplitude.svg';
import { ReactComponent as SynapsesApexAnalytics } from 'design-system/assets/icons/synapses/apex-analytics.svg';
import { ReactComponent as SynapsesAzureBlobStorage } from 'design-system/assets/icons/synapses/azure-blob-storage.svg';
import { ReactComponent as SynapsesAzuresql } from 'design-system/assets/icons/synapses/azuresql.svg';
import { ReactComponent as SynapsesBigquery } from 'design-system/assets/icons/synapses/bigquery.svg';
import { ReactComponent as SynapsesBusinessCentral } from 'design-system/assets/icons/synapses/business-central.svg';
import { ReactComponent as SynapsesChargebee } from 'design-system/assets/icons/synapses/chargebee.svg';
import { ReactComponent as SynapsesCustomHttpSynapse } from 'design-system/assets/icons/synapses/custom-http-synapse.svg';
import { ReactComponent as SynapsesCustomSynapse } from 'design-system/assets/icons/synapses/custom-synapse.svg';
import { ReactComponent as SynapsesDataset } from 'design-system/assets/icons/synapses/dataset.svg';
import { ReactComponent as SynapsesDrift } from 'design-system/assets/icons/synapses/drift.svg';
import { ReactComponent as SynapsesDynamics365 } from 'design-system/assets/icons/synapses/dynamics365.svg';
import { ReactComponent as SynapsesDynamodb } from 'design-system/assets/icons/synapses/dynamodb.svg';
import { ReactComponent as SynapsesEloqua } from 'design-system/assets/icons/synapses/eloqua.svg';
import { ReactComponent as SynapsesFreshsales } from 'design-system/assets/icons/synapses/freshsales.svg';
import { ReactComponent as SynapsesGainsight } from 'design-system/assets/icons/synapses/gainsight.svg';
import { ReactComponent as SynapsesGooglesheets } from 'design-system/assets/icons/synapses/googlesheets.svg';
import { ReactComponent as SynapsesHubspot } from 'design-system/assets/icons/synapses/hubspot.svg';
import { ReactComponent as SynapsesImpartner } from 'design-system/assets/icons/synapses/impartner.svg';
import { ReactComponent as SynapsesImportedFiles } from 'design-system/assets/icons/synapses/imported-files.svg';
import { ReactComponent as SynapsesIntacct } from 'design-system/assets/icons/synapses/intacct.svg';
import { ReactComponent as SynapsesIntercom } from 'design-system/assets/icons/synapses/intercom.svg';
import { ReactComponent as SynapsesJiraServiceDesk } from 'design-system/assets/icons/synapses/jira-service-desk.svg';
import { ReactComponent as SynapsesJira } from 'design-system/assets/icons/synapses/jira.svg';
import { ReactComponent as SynapsesKinesis } from 'design-system/assets/icons/synapses/kinesis.svg';
import { ReactComponent as SynapsesMarketo } from 'design-system/assets/icons/synapses/marketo.svg';
import { ReactComponent as SynapsesMicrosoftexcel } from 'design-system/assets/icons/synapses/microsoftexcel.svg';
import { ReactComponent as SynapsesMixpanel } from 'design-system/assets/icons/synapses/mixpanel.svg';
import { ReactComponent as SynapsesMsdynamics } from 'design-system/assets/icons/synapses/msdynamics.svg';
import { ReactComponent as SynapsesMysql } from 'design-system/assets/icons/synapses/mysql.svg';
import { ReactComponent as SynapsesNetsuite } from 'design-system/assets/icons/synapses/netsuite.svg';
import { ReactComponent as SynapsesOkta } from 'design-system/assets/icons/synapses/okta.svg';
import { ReactComponent as SynapsesOracle } from 'design-system/assets/icons/synapses/oracle.svg';
import { ReactComponent as SynapsesOraclerds } from 'design-system/assets/icons/synapses/oraclerds.svg';
import { ReactComponent as SynapsesOraclesalescrm } from 'design-system/assets/icons/synapses/oraclesalescrm.svg';
import { ReactComponent as SynapsesOutreach } from 'design-system/assets/icons/synapses/outreach.svg';
import { ReactComponent as SynapsesPardot } from 'design-system/assets/icons/synapses/pardot.svg';
import { ReactComponent as SynapsesPendo } from 'design-system/assets/icons/synapses/pendo.svg';
import { ReactComponent as SynapsesPostgres } from 'design-system/assets/icons/synapses/postgres.svg';
import { ReactComponent as SynapsesRedshift } from 'design-system/assets/icons/synapses/redshift.svg';
import { ReactComponent as SynapsesS3 } from 'design-system/assets/icons/synapses/s3.svg';
import { ReactComponent as SynapsesSalesforce } from 'design-system/assets/icons/synapses/salesforce.svg';
import { ReactComponent as SynapsesSalesloft } from 'design-system/assets/icons/synapses/salesloft.svg';
import { ReactComponent as SynapsesSap } from 'design-system/assets/icons/synapses/sap.svg';
import { ReactComponent as SynapsesSegment } from 'design-system/assets/icons/synapses/segment.svg';
import { ReactComponent as SynapsesSfcloud } from 'design-system/assets/icons/synapses/sfcloud.svg';
import { ReactComponent as SynapsesSftp } from 'design-system/assets/icons/synapses/sftp.svg';
import { ReactComponent as SynapsesShopify } from 'design-system/assets/icons/synapses/shopify.svg';
import { ReactComponent as SynapsesSlack } from 'design-system/assets/icons/synapses/slack.svg';
import { ReactComponent as SynapsesSnowflake } from 'design-system/assets/icons/synapses/snowflake.svg';
import { ReactComponent as SynapsesStripe } from 'design-system/assets/icons/synapses/stripe.svg';
import { ReactComponent as SynapsesSyncari } from 'design-system/assets/icons/synapses/syncari.svg';
import { ReactComponent as SynapsesWebhook } from 'design-system/assets/icons/synapses/webhook.svg';
import { ReactComponent as SynapsesXero } from 'design-system/assets/icons/synapses/xero.svg';
import { ReactComponent as SynapsesZendesk } from 'design-system/assets/icons/synapses/zendesk.svg';
import { ReactComponent as SynapsesZohoCrm } from 'design-system/assets/icons/synapses/zoho-crm.svg';
import { ReactComponent as SynapsesZoominfo } from 'design-system/assets/icons/synapses/zoominfo.svg';
import { ReactComponent as SynapsesZuora } from 'design-system/assets/icons/synapses/zuora.svg';

import type { IconName } from '../../types';

export const ICON_REGISTRY: Record<IconName, React.FC<React.SVGProps<SVGSVGElement>>> = {
  'actionable/add': ActionableAdd,
  'actionable/area-field': ActionableAreaField,
  'actionable/arrow-left': ActionableArrowLeft,
  'actionable/arrow-right': ActionableArrowRight,
  'actionable/arrow-up': ActionableArrowUp,
  'actionable/back': ActionableBack,
  'actionable/chevron-collapse': ActionableChevronCollapse,
  'actionable/chevron-expand': ActionableChevronExpand,
  'actionable/chevron-left': ActionableChevronLeft,
  'actionable/chevron-right': ActionableChevronRight,
  'actionable/clear': ActionableClear,
  'actionable/clone': ActionableClone,
  'actionable/close': ActionableClose,
  'actionable/collapse-height': ActionableCollapseHeight,
  'actionable/collapse': ActionableCollapse,
  'actionable/copy': ActionableCopy,
  'actionable/create-draft': ActionableCreateDraft,
  'actionable/delete-bin': ActionableDeleteBin,
  'actionable/delete-outline': ActionableDeleteOutline,
  'actionable/delete': ActionableDelete,
  'actionable/edit': ActionableEdit,
  'actionable/expand-height': ActionableExpandHeight,
  'actionable/expand': ActionableExpand,
  'actionable/export': ActionableExport,
  'actionable/eye-off': ActionableEyeOff,
  'actionable/eye-on': ActionableEyeOn,
  'actionable/feedback': ActionableFeedback,
  'actionable/field-map': ActionableFieldMap,
  'actionable/fields': ActionableFields,
  'actionable/file': ActionableFile,
  'actionable/filter-1': ActionableFilter1,
  'actionable/filter': ActionableFilter,
  'actionable/forward': ActionableForward,
  'actionable/generate-key': ActionableGenerateKey,
  'actionable/group': ActionableGroup,
  'actionable/handle': ActionableHandle,
  'actionable/insights-resend-email': ActionableInsightsResendEmail,
  'actionable/kebab': ActionableKebab,
  'actionable/lineage': ActionableLineage,
  'actionable/merge-studio': ActionableMergeStudio,
  'actionable/merge': ActionableMerge,
  'actionable/nest-condition': ActionableNestCondition,
  'actionable/note': ActionableNote,
  'actionable/operations': ActionableOperations,
  'actionable/palette': ActionablePalette,
  'actionable/pipeline-open-version': ActionablePipelineOpenVersion,
  'actionable/pipeline-pause': ActionablePipelinePause,
  'actionable/pipeline-restore-version': ActionablePipelineRestoreVersion,
  'actionable/pipeline-resume': ActionablePipelineResume,
  'actionable/pipeline-visual-changes': ActionablePipelineVisualChanges,
  'actionable/refresh': ActionableRefresh,
  'actionable/remove-group': ActionableRemoveGroup,
  'actionable/schedule': ActionableSchedule,
  'actionable/search': ActionableSearch,
  'actionable/send-bottom': ActionableSendBottom,
  'actionable/send-top': ActionableSendTop,
  'actionable/settings-filled': ActionableSettingsFilled,
  'actionable/settings': ActionableSettings,
  'actionable/spinner': ActionableSpinner,
  'actionable/status': ActionableStatus,
  'actionable/tag-variant': ActionableTagVariant,
  'actionable/tags': ActionableTags,
  'actionable/tick': ActionableTick,
  'actionable/undo': ActionableUndo,
  'actionable/ungroup': ActionableUngroup,
  'actionable/upload-file': ActionableUploadFile,
  'actionable/upload': ActionableUpload,
  'actionable/view-configuration': ActionableViewConfiguration,
  'actions/add-to-list': ActionsAddToList,
  'actions/add-to-marketo-program': ActionsAddToMarketoProgram,
  'actions/add-to-salesforce-campaign': ActionsAddToSalesforceCampaign,
  'actions/address-gpt': ActionsAddressGpt,
  'actions/convert-salesforce-lead': ActionsConvertSalesforceLead,
  'actions/create-external-record': ActionsCreateExternalRecord,
  'actions/create-file': ActionsCreateFile,
  'actions/create-ms-teams-channel': ActionsCreateMsTeamsChannel,
  'actions/create-salesforcce-file': ActionsCreateSalesforcceFile,
  'actions/create-salesforcce-task': ActionsCreateSalesforcceTask,
  'actions/create-syncari-record': ActionsCreateSyncariRecord,
  'actions/create-zendesk-ticket': ActionsCreateZendeskTicket,
  'actions/custom-action-1': ActionsCustomAction1,
  'actions/custom-action': ActionsCustomAction,
  'actions/delete-external-record': ActionsDeleteExternalRecord,
  'actions/delete-syncari-record': ActionsDeleteSyncariRecord,
  'actions/export-records-to-csv': ActionsExportRecordsToCsv,
  'actions/generic_action': ActionsGenericAction,
  'actions/microsoft-teams': ActionsMicrosoftTeams,
  'actions/name-gpt': ActionsNameGpt,
  'actions/placeholder-action': ActionsPlaceholderAction,
  'actions/remove-from-marketo-list': ActionsRemoveFromMarketoList,
  'actions/respond-to-webhook': ActionsRespondToWebhook,
  'actions/retry-record': ActionsRetryRecord,
  'actions/send-email': ActionsSendEmail,
  'actions/send-slack-message': ActionsSendSlackMessage,
  'actions/sentiment-gpt': ActionsSentimentGpt,
  'actions/slack--send-message': ActionsSlackSendMessage,
  'actions/update-external-record': ActionsUpdateExternalRecord,
  'actions/update-syncari-record': ActionsUpdateSyncariRecord,
  'brand/avatar': BrandAvatar,
  'brand/brand-collapsed': BrandBrandCollapsed,
  'brand/brand-expanded': BrandBrandExpanded,
  'brand/syncaroo': BrandSyncaroo,
  'field-type/boolean': FieldTypeBoolean,
  'field-type/date': FieldTypeDate,
  'field-type/datetime': FieldTypeDatetime,
  'field-type/double': FieldTypeDouble,
  'field-type/id': FieldTypeId,
  'field-type/integer': FieldTypeInteger,
  'field-type/object': FieldTypeObject,
  'field-type/picklist': FieldTypePicklist,
  'field-type/reference': FieldTypeReference,
  'field-type/textarea': FieldTypeTextarea,
  'field-type/url': FieldTypeUrl,
  'functions/absolute-value': FunctionsAbsoluteValue,
  'functions/add-to-date': FunctionsAddToDate,
  'functions/add-to-list': FunctionsAddToList,
  'functions/add': FunctionsAdd,
  'functions/aidentified-people-enrichment': FunctionsAidentifiedPeopleEnrichment,
  'functions/apexanalytic-company-enrichment': FunctionsApexanalyticCompanyEnrichment,
  'functions/attach-record': FunctionsAttachRecord,
  'functions/auto-increment': FunctionsAutoIncrement,
  'functions/average': FunctionsAverage,
  'functions/cache': FunctionsCache,
  'functions/camel-case': FunctionsCamelCase,
  'functions/capitalize': FunctionsCapitalize,
  'functions/ceiling': FunctionsCeiling,
  'functions/character-at-index': FunctionsCharacterAtIndex,
  'functions/compute-data-quality': FunctionsComputeDataQuality,
  'functions/compute-ratio': FunctionsComputeRatio,
  'functions/computing-data-quality': FunctionsComputingDataQuality,
  'functions/concatenate': FunctionsConcatenate,
  'functions/convert-json-to-string': FunctionsConvertJsonToString,
  'functions/count': FunctionsCount,
  'functions/date-difference': FunctionsDateDifference,
  'functions/date-format': FunctionsDateFormat,
  'functions/day-of-month': FunctionsDayOfMonth,
  'functions/day-of-week': FunctionsDayOfWeek,
  'functions/day-of-year': FunctionsDayOfYear,
  'functions/decision': FunctionsDecision,
  'functions/decode': FunctionsDecode,
  'functions/decrement-value': FunctionsDecrementValue,
  'functions/decrypt': FunctionsDecrypt,
  'functions/deduplicate': FunctionsDeduplicate,
  'functions/encode': FunctionsEncode,
  'functions/encrypt': FunctionsEncrypt,
  'functions/enrich-company': FunctionsEnrichCompany,
  'functions/enrich-person': FunctionsEnrichPerson,
  'functions/extract-domain': FunctionsExtractDomain,
  'functions/extract-text': FunctionsExtractText,
  'functions/find-in-list': FunctionsFindInList,
  'functions/first': FunctionsFirst,
  'functions/floor': FunctionsFloor,
  'functions/generic_function': FunctionsGenericFunction,
  'functions/get-list-item': FunctionsGetListItem,
  'functions/increment-value': FunctionsIncrementValue,
  'functions/index-of': FunctionsIndexOf,
  'functions/is-after-now': FunctionsIsAfterNow,
  'functions/is-before-now': FunctionsIsBeforeNow,
  'functions/is-empty': FunctionsIsEmpty,
  'functions/join': FunctionsJoin,
  'functions/last': FunctionsLast,
  'functions/length-1': FunctionsLength1,
  'functions/length': FunctionsLength,
  'functions/lookup-dataset-records': FunctionsLookupDatasetRecords,
  'functions/lookup-external-records': FunctionsLookupExternalRecords,
  'functions/lookup-syncari-records': FunctionsLookupSyncariRecords,
  'functions/loop-1': FunctionsLoop1,
  'functions/loop': FunctionsLoop,
  'functions/lower': FunctionsLower,
  'functions/lpad': FunctionsLpad,
  'functions/ltrim-1': FunctionsLtrim1,
  'functions/ltrim': FunctionsLtrim,
  'functions/maximum-value': FunctionsMaximumValue,
  'functions/md5-hash': FunctionsMd5Hash,
  'functions/md5': FunctionsMd5,
  'functions/minimum-value': FunctionsMinimumValue,
  'functions/multiply': FunctionsMultiply,
  'functions/now': FunctionsNow,
  'functions/parse-json-array': FunctionsParseJsonArray,
  'functions/parse-json-object': FunctionsParseJsonObject,
  'functions/parse-json-to-list': FunctionsParseJsonToList,
  'functions/parse-json-to-object': FunctionsParseJsonToObject,
  'functions/phone-number-format': FunctionsPhoneNumberFormat,
  'functions/placeholder-function': FunctionsPlaceholderFunction,
  'functions/random-number': FunctionsRandomNumber,
  'functions/remove-duplicates': FunctionsRemoveDuplicates,
  'functions/remove-from-list': FunctionsRemoveFromList,
  'functions/remove-non-printable': FunctionsRemoveNonPrintable,
  'functions/replace': FunctionsReplace,
  'functions/reverse-list': FunctionsReverseList,
  'functions/reverse-string': FunctionsReverseString,
  'functions/round': FunctionsRound,
  'functions/rpad': FunctionsRpad,
  'functions/rtrim': FunctionsRtrim,
  'functions/salesintel-company-enrichment': FunctionsSalesintelCompanyEnrichment,
  'functions/set-value': FunctionsSetValue,
  'functions/similarweb-traffic-data': FunctionsSimilarwebTrafficData,
  'functions/sort': FunctionsSort,
  'functions/split': FunctionsSplit,
  'functions/standard-deviation': FunctionsStandardDeviation,
  'functions/strip-tags': FunctionsStripTags,
  'functions/substract-from-date': FunctionsSubstractFromDate,
  'functions/substring': FunctionsSubstring,
  'functions/subtract': FunctionsSubtract,
  'functions/sum': FunctionsSum,
  'functions/switch': FunctionsSwitch,
  'functions/time-ticker': FunctionsTimeTicker,
  'functions/title': FunctionsTitle,
  'functions/translate': FunctionsTranslate,
  'functions/trim': FunctionsTrim,
  'functions/upper': FunctionsUpper,
  'functions/url-encode': FunctionsUrlEncode,
  'functions/uuid': FunctionsUuid,
  'miscellaneous/avatar': MiscellaneousAvatar,
  'miscellaneous/collapse': MiscellaneousCollapse,
  'miscellaneous/error-outline': MiscellaneousErrorOutline,
  'miscellaneous/error': MiscellaneousError,
  'miscellaneous/expand': MiscellaneousExpand,
  'miscellaneous/false': MiscellaneousFalse,
  'miscellaneous/help-outline': MiscellaneousHelpOutline,
  'miscellaneous/help': MiscellaneousHelp,
  'miscellaneous/indicator-blue': MiscellaneousIndicatorBlue,
  'miscellaneous/indicator-green': MiscellaneousIndicatorGreen,
  'miscellaneous/indicator-grey': MiscellaneousIndicatorGrey,
  'miscellaneous/indicator-orange': MiscellaneousIndicatorOrange,
  'miscellaneous/indicator-red': MiscellaneousIndicatorRed,
  'miscellaneous/info--gray-outline': MiscellaneousInfoGrayOutline,
  'miscellaneous/info-gray': MiscellaneousInfoGray,
  'miscellaneous/info-outline': MiscellaneousInfoOutline,
  'miscellaneous/info': MiscellaneousInfo,
  'miscellaneous/instance-logo': MiscellaneousInstanceLogo,
  'miscellaneous/notifications-empty': MiscellaneousNotificationsEmpty,
  'miscellaneous/slash': MiscellaneousSlash,
  'miscellaneous/success-outline': MiscellaneousSuccessOutline,
  'miscellaneous/success': MiscellaneousSuccess,
  'miscellaneous/syncaroo': MiscellaneousSyncaroo,
  'miscellaneous/warning-outline': MiscellaneousWarningOutline,
  'miscellaneous/warning': MiscellaneousWarning,
  'sections/actions': SectionsActions,
  'sections/annotations': SectionsAnnotations,
  'sections/body': SectionsBody,
  'sections/custom-fragments': SectionsCustomFragments,
  'sections/fragments': SectionsFragments,
  'sections/functions': SectionsFunctions,
  'sections/headers': SectionsHeaders,
  'sections/pagination': SectionsPagination,
  'sections/records': SectionsRecords,
  'sections/schema': SectionsSchema,
  'sections/synapse-entities': SectionsSynapseEntities,
  'sections/sync-from-entities': SectionsSyncFromEntities,
  'sections/sync-to-entities': SectionsSyncToEntities,
  'sections/testing': SectionsTesting,
  'sections/variables': SectionsVariables,
  'settings/access-control': SettingsAccessControl,
  'settings/branding': SettingsBranding,
  'settings/data-store': SettingsDataStore,
  'settings/debug-flag': SettingsDebugFlag,
  'settings/insights-sharing': SettingsInsightsSharing,
  'settings/instances': SettingsInstances,
  'settings/notifications': SettingsNotifications,
  'settings/realtime-pipelines': SettingsRealtimePipelines,
  'settings/service-credentials': SettingsServiceCredentials,
  'settings/single-sign-on': SettingsSingleSignOn,
  'settings/subscription-profile': SettingsSubscriptionProfile,
  'settings/users': SettingsUsers,
  'sidebar/business-inactive': SidebarBusinessInactive,
  'sidebar/data-inactive': SidebarDataInactive,
  'sidebar/imported-inactive': SidebarImportedInactive,
  'sidebar/insights-inactive': SidebarInsightsInactive,
  'sidebar/logs-inactive': SidebarLogsInactive,
  'sidebar/option-collapse': SidebarOptionCollapse,
  'sidebar/schema-inactive': SidebarSchemaInactive,
  'sidebar/settings-inactive': SidebarSettingsInactive,
  'sidebar/synapse-inactive': SidebarSynapseInactive,
  'sidebar/sync-inactive': SidebarSyncInactive,
  'sidebar-color/business-active': SidebarColorBusinessActive,
  'sidebar-color/data-active': SidebarColorDataActive,
  'sidebar-color/imported-active': SidebarColorImportedActive,
  'sidebar-color/insights-active': SidebarColorInsightsActive,
  'sidebar-color/logs-active': SidebarColorLogsActive,
  'sidebar-color/option-expand': SidebarColorOptionExpand,
  'sidebar-color/schema-active': SidebarColorSchemaActive,
  'sidebar-color/settings-active': SidebarColorSettingsActive,
  'sidebar-color/synapse-active': SidebarColorSynapseActive,
  'sidebar-color/sync-active': SidebarColorSyncActive,
  'synapses/airtable': SynapsesAirtable,
  'synapses/amplitude': SynapsesAmplitude,
  'synapses/apex-analytics': SynapsesApexAnalytics,
  'synapses/azure-blob-storage': SynapsesAzureBlobStorage,
  'synapses/azuresql': SynapsesAzuresql,
  'synapses/bigquery': SynapsesBigquery,
  'synapses/business-central': SynapsesBusinessCentral,
  'synapses/chargebee': SynapsesChargebee,
  'synapses/custom-http-synapse': SynapsesCustomHttpSynapse,
  'synapses/custom-synapse': SynapsesCustomSynapse,
  'synapses/dataset': SynapsesDataset,
  'synapses/drift': SynapsesDrift,
  'synapses/dynamics365': SynapsesDynamics365,
  'synapses/dynamodb': SynapsesDynamodb,
  'synapses/eloqua': SynapsesEloqua,
  'synapses/freshsales': SynapsesFreshsales,
  'synapses/gainsight': SynapsesGainsight,
  'synapses/googlesheets': SynapsesGooglesheets,
  'synapses/hubspot': SynapsesHubspot,
  'synapses/impartner': SynapsesImpartner,
  'synapses/imported-files': SynapsesImportedFiles,
  'synapses/intacct': SynapsesIntacct,
  'synapses/intercom': SynapsesIntercom,
  'synapses/jira-service-desk': SynapsesJiraServiceDesk,
  'synapses/jira': SynapsesJira,
  'synapses/kinesis': SynapsesKinesis,
  'synapses/marketo': SynapsesMarketo,
  'synapses/microsoftexcel': SynapsesMicrosoftexcel,
  'synapses/mixpanel': SynapsesMixpanel,
  'synapses/msdynamics': SynapsesMsdynamics,
  'synapses/mysql': SynapsesMysql,
  'synapses/netsuite': SynapsesNetsuite,
  'synapses/okta': SynapsesOkta,
  'synapses/oracle': SynapsesOracle,
  'synapses/oraclerds': SynapsesOraclerds,
  'synapses/oraclesalescrm': SynapsesOraclesalescrm,
  'synapses/outreach': SynapsesOutreach,
  'synapses/pardot': SynapsesPardot,
  'synapses/pendo': SynapsesPendo,
  'synapses/postgres': SynapsesPostgres,
  'synapses/redshift': SynapsesRedshift,
  'synapses/s3': SynapsesS3,
  'synapses/salesforce': SynapsesSalesforce,
  'synapses/salesloft': SynapsesSalesloft,
  'synapses/sap': SynapsesSap,
  'synapses/segment': SynapsesSegment,
  'synapses/sfcloud': SynapsesSfcloud,
  'synapses/sftp': SynapsesSftp,
  'synapses/shopify': SynapsesShopify,
  'synapses/slack': SynapsesSlack,
  'synapses/snowflake': SynapsesSnowflake,
  'synapses/stripe': SynapsesStripe,
  'synapses/syncari': SynapsesSyncari,
  'synapses/webhook': SynapsesWebhook,
  'synapses/xero': SynapsesXero,
  'synapses/zendesk': SynapsesZendesk,
  'synapses/zoho-crm': SynapsesZohoCrm,
  'synapses/zoominfo': SynapsesZoominfo,
  'synapses/zuora': SynapsesZuora,
};

/**
 * Icons that ship with their own multi-color fills (brand logos, illustrations).
 * The DS Icon component skips the `variant` color treatment for these so the
 * embedded colors render as designed.
 */
export const COLORED_ICONS: ReadonlySet<IconName> = new Set<IconName>([
  'actions/add-to-list',
  'actions/add-to-marketo-program',
  'actions/add-to-salesforce-campaign',
  'actions/address-gpt',
  'actions/convert-salesforce-lead',
  'actions/create-external-record',
  'actions/create-file',
  'actions/create-ms-teams-channel',
  'actions/create-salesforcce-file',
  'actions/create-salesforcce-task',
  'actions/create-syncari-record',
  'actions/create-zendesk-ticket',
  'actions/custom-action-1',
  'actions/custom-action',
  'actions/delete-external-record',
  'actions/delete-syncari-record',
  'actions/export-records-to-csv',
  'actions/generic_action',
  'actions/microsoft-teams',
  'actions/name-gpt',
  'actions/placeholder-action',
  'actions/remove-from-marketo-list',
  'actions/respond-to-webhook',
  'actions/retry-record',
  'actions/send-email',
  'actions/send-slack-message',
  'actions/sentiment-gpt',
  'actions/slack--send-message',
  'actions/update-external-record',
  'actions/update-syncari-record',
  'brand/avatar',
  'brand/brand-collapsed',
  'brand/brand-expanded',
  'brand/syncaroo',
  'functions/absolute-value',
  'functions/add-to-date',
  'functions/add-to-list',
  'functions/add',
  'functions/aidentified-people-enrichment',
  'functions/apexanalytic-company-enrichment',
  'functions/attach-record',
  'functions/auto-increment',
  'functions/average',
  'functions/cache',
  'functions/camel-case',
  'functions/capitalize',
  'functions/ceiling',
  'functions/character-at-index',
  'functions/compute-data-quality',
  'functions/compute-ratio',
  'functions/computing-data-quality',
  'functions/concatenate',
  'functions/convert-json-to-string',
  'functions/count',
  'functions/date-difference',
  'functions/date-format',
  'functions/day-of-month',
  'functions/day-of-week',
  'functions/day-of-year',
  'functions/decision',
  'functions/decode',
  'functions/decrement-value',
  'functions/decrypt',
  'functions/deduplicate',
  'functions/encode',
  'functions/encrypt',
  'functions/enrich-company',
  'functions/enrich-person',
  'functions/extract-domain',
  'functions/extract-text',
  'functions/find-in-list',
  'functions/first',
  'functions/floor',
  'functions/generic_function',
  'functions/get-list-item',
  'functions/increment-value',
  'functions/index-of',
  'functions/is-after-now',
  'functions/is-before-now',
  'functions/is-empty',
  'functions/join',
  'functions/last',
  'functions/length-1',
  'functions/length',
  'functions/lookup-dataset-records',
  'functions/lookup-external-records',
  'functions/lookup-syncari-records',
  'functions/loop-1',
  'functions/loop',
  'functions/lower',
  'functions/lpad',
  'functions/ltrim-1',
  'functions/ltrim',
  'functions/maximum-value',
  'functions/md5-hash',
  'functions/md5',
  'functions/minimum-value',
  'functions/multiply',
  'functions/now',
  'functions/parse-json-array',
  'functions/parse-json-object',
  'functions/parse-json-to-list',
  'functions/parse-json-to-object',
  'functions/phone-number-format',
  'functions/placeholder-function',
  'functions/random-number',
  'functions/remove-duplicates',
  'functions/remove-from-list',
  'functions/remove-non-printable',
  'functions/replace',
  'functions/reverse-list',
  'functions/reverse-string',
  'functions/round',
  'functions/rpad',
  'functions/rtrim',
  'functions/salesintel-company-enrichment',
  'functions/set-value',
  'functions/similarweb-traffic-data',
  'functions/sort',
  'functions/split',
  'functions/standard-deviation',
  'functions/strip-tags',
  'functions/substract-from-date',
  'functions/substring',
  'functions/subtract',
  'functions/sum',
  'functions/switch',
  'functions/time-ticker',
  'functions/title',
  'functions/translate',
  'functions/trim',
  'functions/upper',
  'functions/url-encode',
  'functions/uuid',
  'miscellaneous/avatar',
  'miscellaneous/collapse',
  'miscellaneous/error-outline',
  'miscellaneous/error',
  'miscellaneous/expand',
  'miscellaneous/false',
  'miscellaneous/help-outline',
  'miscellaneous/help',
  'miscellaneous/indicator-blue',
  'miscellaneous/indicator-green',
  'miscellaneous/indicator-grey',
  'miscellaneous/indicator-orange',
  'miscellaneous/indicator-red',
  'miscellaneous/info--gray-outline',
  'miscellaneous/info-gray',
  'miscellaneous/info-outline',
  'miscellaneous/info',
  'miscellaneous/instance-logo',
  'miscellaneous/notifications-empty',
  'miscellaneous/slash',
  'miscellaneous/success-outline',
  'miscellaneous/success',
  'miscellaneous/syncaroo',
  'miscellaneous/warning-outline',
  'miscellaneous/warning',
  'sidebar-color/business-active',
  'sidebar-color/data-active',
  'sidebar-color/imported-active',
  'sidebar-color/insights-active',
  'sidebar-color/logs-active',
  'sidebar-color/option-expand',
  'sidebar-color/schema-active',
  'sidebar-color/settings-active',
  'sidebar-color/synapse-active',
  'sidebar-color/sync-active',
  'synapses/airtable',
  'synapses/amplitude',
  'synapses/apex-analytics',
  'synapses/azure-blob-storage',
  'synapses/azuresql',
  'synapses/bigquery',
  'synapses/business-central',
  'synapses/chargebee',
  'synapses/custom-http-synapse',
  'synapses/custom-synapse',
  'synapses/dataset',
  'synapses/drift',
  'synapses/dynamics365',
  'synapses/dynamodb',
  'synapses/eloqua',
  'synapses/freshsales',
  'synapses/gainsight',
  'synapses/googlesheets',
  'synapses/hubspot',
  'synapses/impartner',
  'synapses/imported-files',
  'synapses/intacct',
  'synapses/intercom',
  'synapses/jira-service-desk',
  'synapses/jira',
  'synapses/kinesis',
  'synapses/marketo',
  'synapses/microsoftexcel',
  'synapses/mixpanel',
  'synapses/msdynamics',
  'synapses/mysql',
  'synapses/netsuite',
  'synapses/okta',
  'synapses/oracle',
  'synapses/oraclerds',
  'synapses/oraclesalescrm',
  'synapses/outreach',
  'synapses/pardot',
  'synapses/pendo',
  'synapses/postgres',
  'synapses/redshift',
  'synapses/s3',
  'synapses/salesforce',
  'synapses/salesloft',
  'synapses/sap',
  'synapses/segment',
  'synapses/sfcloud',
  'synapses/sftp',
  'synapses/shopify',
  'synapses/slack',
  'synapses/snowflake',
  'synapses/stripe',
  'synapses/syncari',
  'synapses/webhook',
  'synapses/xero',
  'synapses/zendesk',
  'synapses/zoho-crm',
  'synapses/zoominfo',
  'synapses/zuora',
]);
